import { PayloadRequest } from 'types/requestTypes'
import { omdApi } from '../../api'

import { } from '../types/cashFlow'
import { CashFlowExpenseSubReportDetailItem, CashFlowExpenseSubReportExtraditionsItem, CashFlowExpenseSubReportItem, CashFlowExpenseSubReportRequest } from '../types/cashFlowExpenseSubReport'

const cashFlowSchemas = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getCashFlowExpenseSubReport: builder.query<CashFlowExpenseSubReportItem, PayloadRequest>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseSubReport/${data.id}`,
      }),
    }),
    changeCashFlowExpenseSubReport: builder.mutation<void, PayloadRequest & CashFlowExpenseSubReportItem>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseSubReport/${data.id}`,
        method: 'PUT',
        body: data
      }),
    }),
    createCashFlowExpenseSubReport: builder.mutation<void, CashFlowExpenseSubReportItem>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseSubReport`,
        method: 'POST',
        body: data
      }),
    }),

    getCashFlowExpenseSubReportDetailList: builder.query<CashFlowExpenseSubReportDetailItem, PayloadRequest>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseSubReport/${data.id}/details`,
      }),
    }),
    getCashFlowExpenseSubReportDetail: builder.query<CashFlowExpenseSubReportDetailItem, CashFlowExpenseSubReportRequest>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseSubReport/${data.cashFlowId}/details/${data.detailId}`,
      }),
    }),
    changeCashFlowExpenseSubReportDetail: builder.mutation<void, CashFlowExpenseSubReportDetailItem>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseSubReport/${data.cashFlowId}/details/${data.detailId}`,
        method: 'PUT',
        body: data
      }),
    }),
    createCashFlowExpenseSubReportDetail: builder.mutation<void, CashFlowExpenseSubReportDetailItem>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseSubReport/${data.cashFlowId}/details`,
        method: 'POST',
        body: data
      }),
    }),
    deleteCashFlowExpenseSubReportDetail: builder.mutation<void, CashFlowExpenseSubReportRequest>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseSubReport/${data.cashFlowId}/details/${data.detailId}`,
        method: 'DELETE',
      }),
    }),


    getCashFlowExpenseSubReportExtraditionsList: builder.query<CashFlowExpenseSubReportExtraditionsItem, PayloadRequest>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseSubReport/${data.id}/extraditions`,
      }),
    }),
    getCashFlowExpenseSubReportExtraditions: builder.query<CashFlowExpenseSubReportExtraditionsItem, CashFlowExpenseSubReportRequest>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseSubReport/${data.cashFlowId}/extraditions/${data.detailId}`,
      }),
    }),
    changeCashFlowExpenseSubReportExtraditions: builder.mutation<void, CashFlowExpenseSubReportExtraditionsItem>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseSubReport/${data.cashFlowId}/extraditions/${data.detailId}`,
        method: 'PUT',
        body: data
      }),
    }),
    createCashFlowExpenseSubReportExtraditions: builder.mutation<void, CashFlowExpenseSubReportExtraditionsItem>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseSubReport/${data.cashFlowId}/extraditions`,
        method: 'POST',
        body: data
      }),
    }),
    deleteCashFlowExpenseSubReportExtraditions: builder.mutation<void, CashFlowExpenseSubReportRequest>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseSubReport/${data.cashFlowId}/extraditions/${data.detailId}`,
        method: 'DELETE',
      }),
    }),
  }),
})

export const {
  useChangeCashFlowExpenseSubReportMutation,
  useCreateCashFlowExpenseSubReportMutation,
  useGetCashFlowExpenseSubReportQuery,
  useLazyGetCashFlowExpenseSubReportQuery,

  useGetCashFlowExpenseSubReportDetailListQuery,
  useGetCashFlowExpenseSubReportDetailQuery,
  useLazyGetCashFlowExpenseSubReportDetailQuery,
  useDeleteCashFlowExpenseSubReportDetailMutation,
  useCreateCashFlowExpenseSubReportDetailMutation,
  useChangeCashFlowExpenseSubReportDetailMutation,

  useChangeCashFlowExpenseSubReportExtraditionsMutation,
  useGetCashFlowExpenseSubReportExtraditionsListQuery,
  useGetCashFlowExpenseSubReportExtraditionsQuery,
  useCreateCashFlowExpenseSubReportExtraditionsMutation,
  useDeleteCashFlowExpenseSubReportExtraditionsMutation,
  useLazyGetCashFlowExpenseSubReportDetailListQuery,
  useLazyGetCashFlowExpenseSubReportExtraditionsListQuery,
  useLazyGetCashFlowExpenseSubReportExtraditionsQuery
} =
cashFlowSchemas
